import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import FloatingWhatsApp from "./components/feature/FloatingWhatsApp";
import { CMSProvider } from "./context/CMSContext";
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <CMSProvider>
        <AuthProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
            <FloatingWhatsApp />
          </BrowserRouter>
        </AuthProvider>
      </CMSProvider>
    </I18nextProvider>
  );
}

export default App;
